import { render, staticRenderFns } from "./ProjectQuestionnaireCreate.vue?vue&type=template&id=62bbb424&"
import script from "./ProjectQuestionnaireCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionnaireCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports